import { useGetUsersTasksDefaultsHosts } from '../../../hooks/queries/users-tasks/defaults/users-tasks-hosts-defaults/use-get-users-tasks-hosts-defaults'
import { TaskItem } from './daily-components/task-item'

export function TasksHosts() {
  const { usersTasksHostsDefaults } = useGetUsersTasksDefaultsHosts()

  return usersTasksHostsDefaults?.map((task) => (
    <TaskItem key={task.id} task={task} type="host" />
  ))
}
